import { useQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";

const useItemSizes = ({categoryName}) => {
    return useQuery({
        queryKey: [`item-sizes-${categoryName}`],
        queryFn: async () => {
            const response = await apiClient.get(`/api/v3/client/vision_order/getCategorySizeList/${categoryName}`);
            return response.data.sizes;
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
        cacheTime: 10 * 60 * 1000, // 10 minutes
    });
};

export default useItemSizes;